import React from "react";
import { UserRound } from "lucide-react";
import TalentDirectory from "./TalentDirectory";

function Trainers() {
    return (
        <TalentDirectory
            title="Hire Trainers"
            subtitle="Corporate and technical trainers for your training programs."
            matchTypes={["trainer"]}
            icon={UserRound}
        />
    );
}

export default Trainers;
